import React, { useState, useEffect } from 'react'
import { Row, Col } from 'react-flexbox-grid'

import { Formik, Form, Field } from '@components/Form'
import Button from '@components/Button'
import Loading from '@components/Loading'

import Logo from '@icons/EEmovelLogo'

import { login, authed } from '@services/auth'

import {
  Main,
  FormContainer,
  FormWrapper,
  LogoWrapper,
  Header,
  ImageContainer,
  Error,
} from './styles'

const image = require('../../assets/images/working-login2.png')

const Login = props => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    authed() && props.history.push('/avaliacao')
  }, [props.history])

  return (
    <Main>
      <FormContainer>
        <FormWrapper>
          <LogoWrapper>
            <Logo />
          </LogoWrapper>
          <Header>Entre na sua conta</Header>
          <Formik
            initialValues={{ email: '', password: '' }}
            onSubmit={values => login(values, setLoading, setError)}
          >
            {({ values, errors, handleSubmit, handleChange }) => (
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col xs={12}>
                    <Field
                      type="email"
                      label="E-mail"
                      name="email"
                      placeholder="Insira o seu e-mail"
                      onChange={handleChange}
                      value={values.email}
                      error={errors.email}
                      labelWhite
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <Field
                      type="password"
                      label="Senha"
                      name="password"
                      placeholder="Insira a sua senha"
                      onChange={handleChange}
                      value={values.password}
                      error={errors.password}
                      labelWhite
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <Button type="submit" label="Continuar" block />
                  </Col>
                </Row>
                {error && (
                  <Row>
                    <Col xs={12}>
                      <Error>{error}</Error>
                    </Col>
                  </Row>
                )}
              </Form>
            )}
          </Formik>
        </FormWrapper>
      </FormContainer>
      <ImageContainer src={image} />
      {loading && <Loading />}
    </Main>
  )
}

export default Login
